import { useMediaQuery } from 'react-responsive'

export default function MobileSectionHandler({ children, sections, selectedSection, onSectionClose }) {
    const isMobile = useMediaQuery({ query: '(max-width: 568px)' })

    const section = sections[selectedSection] || null;

    return (
        <div className="mobile-section-handler">
            <div className={`mobile-section-handler__screen ${selectedSection != null && isMobile ? 'mobile-section-handler__screen--toggled' : ''}`}>
                { selectedSection !== null && isMobile && <div className="mobile-section-handler__screen__head">
                    <p>{ section.name }</p>
                    <p className="mobile-section-handler__screen__close" onClick={onSectionClose}>Close</p>
                </div> }

                <div className={`mobile-section-handler__mobile ${selectedSection !== null && isMobile ? 'mobile-section-handler__mobile--toggled' : ''}`}>
                    {
                        children.map((child, index) => {
                            return (
                                <div className={`mobile-section-handler__preview layout__inner-container ${selectedSection == index ? 'mobile-section-handler__preview--toggled' : ''}`}>{ child }</div>
                            )
                        })
                    }
                </div>

                <div className={`mobile-section-handler__desktop ${selectedSection !== null && isMobile ? 'mobile-section-handler__desktop--toggled' : ''}`}>
                    {
                        children.map((child) => <div className={`layout__inner-container`}>{ child }</div>)
                    }
                </div>
            </div>
        </div>
    )
}
